import React from 'react'
import cn from 'classnames'

import { SIconSpan } from '../../styles/Icons'

export function CheckMarkIcon({ className, size = 24, color = '#81E18B', title, id }: IIConProps): React.ReactElement {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 22 22"
                fill="none"
                className={cn(className)}
                data-testid="checkMarkIcon"
                version="1.1"
                id="svg12"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs id="defs16" />
                <path
                    d="m 19.660015,6 -8.83,8.83 c -0.76003,0.75 -1.76003,1.17 -2.83003,1.17 -1.07,0 -2.07,-0.42 -2.83,-1.17 l -2.83,-2.83 h 2.83 l 1.41,1.41 c 0.76,0.76 2.08,0.76 2.83,0 L 16.820015,6 Z"
                    fill={color ?? 'currentColor'}
                    id="path10"
                />
            </svg>
        </SIconSpan>
    )
}
